var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'has-value': _vm.value, 'has-focus': _vm.hasFocus}},[_c('input',{ref:"inputTarget",staticClass:"form-control",attrs:{"disabled":_vm.disabled,"type":"text"}})])}
var staticRenderFns = []

export { render, staticRenderFns }